import { Component, HostListener, OnInit, Renderer2 } from '@angular/core'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'
import { FeaturedCardLayout } from 'src/app/shared/enums/featured-card-layout.enum'
import { BreadcrumbLink } from 'src/app/shared/interfaces/breadcrumb-link.interface'
import { Page } from 'src/app/shared/interfaces/page.interface'
import { FeaturedCard } from 'src/app/shared/interfaces/resources/featured-card.interface'
import { Post } from 'src/app/shared/interfaces/resources/post.interface'
import { TaxonomyTerm } from 'src/app/shared/interfaces/taxonomy-term.interface'
import { StripHtmlPipe } from 'src/app/shared/pipes/strip-html.pipe'
import { FeaturedCardService } from 'src/app/shared/services/featured-card.service'
import { MetaService } from 'src/app/shared/services/meta.service'
import { PageService } from 'src/app/shared/services/page-service/page.service'
import { PostService } from 'src/app/shared/services/post.service'
import { TagService } from 'src/app/shared/services/tag.service'

@Component({
  selector: 'app-generative-ai-overview',
  templateUrl: './generative-ai-overview.component.html',
  styleUrls: ['./generative-ai-overview.component.scss']
})
export class GenerativeAiOverviewComponent implements OnInit {
  breadcrumbLinks: BreadcrumbLink[]
  policies: FeaturedCard[]
  featuredCards: FeaturedCard[]
  relatedPosts: Post[]
  page: Page
  tag: TaxonomyTerm
  loading: boolean
  loadingPosts: boolean
  loadingPolicies: boolean
  loadingFeaturedCards: boolean
  isOpen = false

  FeaturedCardLayout = FeaturedCardLayout
  videoUrl: SafeResourceUrl

  constructor(
    private pageService: PageService,
    private featuredCardService: FeaturedCardService,
    private postService: PostService,
    private tagService: TagService,
    private sanitizer: DomSanitizer,
    private renderer: Renderer2,
    private metaService: MetaService,
    private stripHtmlPipe: StripHtmlPipe
  ) {}

  async ngOnInit() {
    this.loading = true
    this.loadingPosts = true
    this.loadingPolicies = true
    this.loadingFeaturedCards = true

    this.page = await this.pageService.show('generative-ai-overview')
    this.loading = false

    this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.page.link1
    )

    this.policies = await this.featuredCardService.list({
      featuredOnGenerativeAIOnly: true
    })
    this.loadingPolicies = false

    this.relatedPosts = await this.postService.listUnpaginated({
      tagId: this.page.relatedPostTagIds[0]
    })
    this.loadingPosts = false

    this.featuredCards = this.page.featuredCardIds
      ? await this.featuredCardService.listByIds(this.page.featuredCardIds)
      : []
    this.loadingFeaturedCards = false

    this.tag = await this.tagService.show(this.page.relatedPostTagIds[0])

    this.metaService.setTags({
      title: this.page.metaTitle || this.page.title,
      description: this.stripHtmlPipe.transform(
        this.page.metaDescription || this.page.excerpt
      ),
      path: this.page.slug,
      absoluteOgImage: this.page.image
        ? this.page.image.socialCard
        : this.metaService.defaultMeta.absoluteOgImage
    })
  }

  @HostListener('document:click', ['$event.target'])
  onClick(target: any) {
    // We track clicks to close model if open and click outside
    if (this.isOpen && target.className === 'modal-background') {
      this.isOpen = false
      // Stop YouTube video from playing by resetting its source.
      const playerEl: Element = document.querySelector('#youtube-player')
      this.renderer.setAttribute(playerEl, 'src', '')
    }
  }
}
